import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { ReplaySubject, zip } from 'rxjs';
import { map } from 'rxjs/operators';
import { HeimvorteilGebaeudeart, HeimvorteilProduktart } from '../../../../shared/enum';
import { IHvPaket } from '../../../models/hvpaket';
import { DataService } from '../../../service/data.service';
import { HvPaketComponent } from './hv-paket/hv-paket.component';

@Component({
  selector: 'app-calculatehv-zusatzpakete',
  templateUrl: './calculatehv-zusatzpakete.component.html',
  styleUrls: ['./calculatehv-zusatzpakete.component.scss']
})
export class CalculateHvZusatzpaketeComponent implements OnInit {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  produktart: HeimvorteilProduktart;

  @Input()
  gebaeudeart: HeimvorteilGebaeudeart;

  @Input()
  expertMode: boolean;

  @Input()
  eHTopVersicherung = false;

  @Input()
  hHTopVersicherung = false;

  @Input()
  ehVollschutz = false;

  @Input()
  hvHaushaltPakete: ReplaySubject<Array<IHvPaket>>;

  @Input()
  hvEigenheimPakete: ReplaySubject<Array<IHvPaket>>;

  @Output()
  calculateRatePendingEvent = new EventEmitter<void>();

  previewPaket: IHvPaket;

  @ViewChildren(HvPaketComponent) hvPaketComponents: QueryList<HvPaketComponent>;

  constructor(private fb: UntypedFormBuilder, public dataService: DataService, private ref: ChangeDetectorRef) { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      zusatzpakete: fb.array([]),
    });
  }

  ngOnInit(): void {
    this.hvPakete.subscribe((res) => {
      this.zusatzpakete.clear();
      res.forEach(() => {
        this.zusatzpakete.push(HvPaketComponent.createFormGroup(this.fb, this.expertMode));
      });
      this.ref.detectChanges();
      if (res.length > 0) {
        this.previewPaket = res[0].Paket;
      }
    });
  }

  get zusatzpakete() { return this.formGroup.get('zusatzpakete') as UntypedFormArray; }

  get hvPakete() {
    return zip(this.hvHaushaltPakete, this.hvEigenheimPakete)
      .pipe(map(data => data[0].map(data => ({ Produktart: HeimvorteilProduktart.Haushalt, Paket: data }))
        .concat(data[1].map(data => ({ Produktart: HeimvorteilProduktart.Eigenheim, Paket: data })))));
  }

  showPaket(paket): void {
    if (this.previewPaket && this.previewPaket.Id !== paket.Id) {
      const hvPaketComponent = this.hvPaketComponents.filter(hvPaketComponent => hvPaketComponent.paket.Id === this.previewPaket.Id)[0];
      hvPaketComponent.formGroup.markAllAsTouched();
      if (hvPaketComponent.formGroup.valid) {
        this.previewPaket = paket;
      }
    } else {
      this.previewPaket = paket;
    }
  }

  isSelected(paket): boolean {
    return this.hvPaketComponents.some(hvPaketComponent => hvPaketComponent.paket.Id === paket.Id && hvPaketComponent.selected.value);
  }

  onCalculateRatePending() {
    this.calculateRatePendingEvent.emit();
  }

  getZusatzpaketeEigenheim(): Array<IHvPaket> {
    return this.hvPaketComponents.filter(hvPaketComponent => hvPaketComponent.getZusatzpaket() !== null &&
      hvPaketComponent.produktart === HeimvorteilProduktart.Eigenheim)
      .map(hvPaketComponent => hvPaketComponent.getZusatzpaket());
  }

  getZusatzpaketeHaushalt(): Array<IHvPaket> {
    return this.hvPaketComponents.filter(hvPaketComponent => hvPaketComponent.getZusatzpaket() !== null &&
      hvPaketComponent.produktart === HeimvorteilProduktart.Haushalt)
      .map(hvPaketComponent => hvPaketComponent.getZusatzpaket());
  }

  setZusatzpakete(pakete: Array<IHvPaket>) {
    for (const paket of pakete) {
      const p = this.hvPaketComponents.find(hvPaketComponent => hvPaketComponent.paket.Id === paket.Id);
      p.setZusatzpaket(paket);
    }
    this.ref.detectChanges();
  }

}
